var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{name:'dashboard'}}},[_c('img',{attrs:{"src":require("@/assets/scrm-logo.png"),"alt":"logo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }